// Generated file - do not change manually!

/**
 * Different types of overflow modes.
 */
export enum TabsOverflowMode {
  /**
   * End type is used if there should be only one overflow with hidden the tabs at the end of the tab container.
   */
  End = 'End',

  /**
   * StartAndEnd type is used if there should be two overflows on both ends of the tab container.
   */
  StartAndEnd = 'StartAndEnd'
}
